var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var template = "\n  <div class=\"modal\">\n    <transition :name=\"$effect\" mode=\"out-in\">\n      <div v-if=\"openPayload\" class=\"modal__scroll\">\n        <div class=\"modal__view\" @mousedown=\"closeFromView\" ref=\"view\">\n          <div class=\"modal__frame\" :class=\"innerClass\">\n              <div class=\"modal__header\">\n                <div class=\"modal__title\">\n                  {{title}}\n                </div>\n                <a v-if=\"$closable\" class=\"modal__close-icon\" @click=\"closeAction\"></a>\n              </div>\n              <div class=\"modal__body\">\n                <slot></slot>\n              </div>\n            </div>\n        </div>\n      </div>\n    </transition>\n    <transition :name=\"$backgroundEffect\" mode=\"out-in\">\n      <div v-if=\"openPayload\" class=\"modal__bg\"></div>\n    </transition>\n  </div>\n";
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { $ } from '../../simpli';
export var Event = new Vue();
var ModalController = /** @class */ (function () {
    function ModalController() {
        this.defaultBody = document.body;
        this.defaultTransition = 'fade';
        this.defaultBackgroundTransition = 'fade';
        this.defaultClosable = true;
        this.defaultCloseOutside = true;
    }
    ModalController.prototype.open = function (name, payload) {
        Event.$emit('open', name, payload);
    };
    ModalController.prototype.close = function (name) {
        Event.$emit('close', name);
    };
    ModalController.prototype.toggle = function (name, payload) {
        Event.$emit('toggle', name, payload);
    };
    ModalController.prototype.closeAll = function () {
        Event.$emit('closeAll');
    };
    return ModalController;
}());
export { ModalController };
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.$effect = null;
        _this.$backgroundEffect = null;
        _this.$closable = true;
        _this.$closeOutside = true;
        _this.body = null;
        _this.bodyOverflowY = null;
        _this.valueFallback = null; // used only if the v-model is undefined
        return _this;
    }
    Object.defineProperty(Modal.prototype, "openPayload", {
        get: function () {
            return this.value || this.valueFallback;
        },
        set: function (val) {
            if (this.value === undefined) {
                this.valueFallback = val;
            }
            this.$emit('input', val);
            if (val !== null) {
                this.$emit('open', val !== 'payload_sentinel' ? val : undefined);
            }
            else {
                this.$emit('close');
            }
        },
        enumerable: true,
        configurable: true
    });
    Modal.prototype.stateEvent = function (val) {
        if (this.body) {
            if (val) {
                this.body.style.overflowY = 'hidden';
            }
            else {
                this.body.style.overflowY = this.bodyOverflowY || 'unset';
            }
        }
    };
    Modal.prototype.openAction = function (payload) {
        this.openPayload = payload != null ? payload : 'payload_sentinel';
    };
    Modal.prototype.closeAction = function (force) {
        if (force === void 0) { force = false; }
        if (this.$closable || force) {
            this.openPayload = null;
        }
    };
    Modal.prototype.closeFromView = function (e) {
        if (e.target === this.$refs.view && this.$closeOutside) {
            this.closeAction();
        }
    };
    Modal.prototype.applyProps = function () {
        this.$effect = this.effect || $.modal.defaultTransition;
        this.$backgroundEffect = this.backgroundEffect || $.modal.defaultBackgroundTransition;
        this.$closable = this.closable !== undefined ? this.closable : $.modal.defaultClosable;
        this.$closeOutside = this.closeOutside !== undefined ? this.closeOutside : $.modal.defaultCloseOutside;
    };
    Modal.prototype.beforeMount = function () {
        var _this = this;
        this.applyProps();
        this.body = $.modal.defaultBody;
        this.bodyOverflowY = this.body.style.overflowY;
        Event.$on('open', function (name, payload) {
            if (name === _this.name) {
                _this.openAction(payload);
            }
        });
        Event.$on('close', function (name) {
            if (name === _this.name) {
                _this.openPayload = null;
            }
        });
        Event.$on('toggle', function (name, payload) {
            if (name === _this.name) {
                if (_this.openPayload) {
                    _this.openPayload = null;
                }
                else {
                    _this.openAction(payload);
                }
            }
        });
        Event.$on('closeAll', function () {
            _this.openPayload = null;
        });
    };
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], Modal.prototype, "value", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], Modal.prototype, "name", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], Modal.prototype, "title", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], Modal.prototype, "innerClass", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], Modal.prototype, "effect", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], Modal.prototype, "backgroundEffect", void 0);
    __decorate([
        Prop({ type: Boolean, default: undefined }),
        __metadata("design:type", Boolean)
    ], Modal.prototype, "closable", void 0);
    __decorate([
        Prop({ type: Boolean, default: undefined }),
        __metadata("design:type", Boolean)
    ], Modal.prototype, "closeOutside", void 0);
    __decorate([
        Watch('openPayload'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], Modal.prototype, "stateEvent", null);
    __decorate([
        Watch('effect'),
        Watch('backgroundEffect'),
        Watch('closable'),
        Watch('closeOutside'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Modal.prototype, "applyProps", null);
    Modal = __decorate([
        Component({ template: template })
    ], Modal);
    return Modal;
}(Vue));
export { Modal };
//# sourceMappingURL=Modal.js.map